document.addEventListener('alpine:init', () => {
  Alpine.data('ThemeModule_ModalCart', ({ openOnAddToCart }) => {
    return {
      init() {
        document.addEventListener('shapes:modalcart:afterremoveitem', (event) => {
          console.log('Product removed:', event);
        });

        document.addEventListener('shapes:modalcart:afteradditem', (event) => {
          console.log('Product added:', event);
          if (openOnAddToCart) {
            Alpine.store('modals').open('cart');
          }
        });

        document.addEventListener('shapes:modalcart:quantitychanged', (event) => {
          console.log('Quantity changed:', event);
        });

        Alpine.store('modals').register('cart', 'rightDrawer');
      }
    };
  });
});